/**

 * Controller / brand constants for legal pages.

 * Empty `pec` is omitted in UI. Company P.IVA not set yet (persona fisica — CF only).

 * Contact email is the single source of truth for site mailto links.

 */



const CONTACT_EMAIL = "cookly.studio.dlpm@gmail.com";



export const LEGAL = {

  siteName: "Cookly",

  siteUrl: "https://cookly.studio",

  lastUpdated: "2026-08-08",

  controller: {

    legalName: "Damian Perez Mendoza",

    address: "Via San Simone 2P",

    vatOrTaxId: "PRZDNL99A20Z504C",

    email: CONTACT_EMAIL,

    pec: "",

  },

  contactEmail: CONTACT_EMAIL,

  analyticsEnabledByEnv: process.env.REACT_APP_ENABLE_ANALYTICS === "true",

};



/** True when any controller field still carries an operator placeholder. */

export function hasControllerPlaceholders() {

  const { legalName, address, vatOrTaxId, pec } = LEGAL.controller;

  return [legalName, address, vatOrTaxId, pec].some((value) =>

    String(value).includes("[DA COMPILARE"),

  );

}


